import React from 'react';
import { X } from 'lucide-react';

// Stable palette assignment: a tag with no explicit colour still gets a
// consistent one derived from its slug, so the same tag looks the same
// everywhere without anyone having to configure it.
const PALETTE = [
  'bg-indigo-500/15 text-indigo-300 border-indigo-500/30',
  'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  'bg-amber-500/15 text-amber-300 border-amber-500/30',
  'bg-sky-500/15 text-sky-300 border-sky-500/30',
  'bg-rose-500/15 text-rose-300 border-rose-500/30',
  'bg-violet-500/15 text-violet-300 border-violet-500/30',
  'bg-teal-500/15 text-teal-300 border-teal-500/30',
  'bg-orange-500/15 text-orange-300 border-orange-500/30',
];

const hashToPalette = (value) => {
  const str = String(value || '');
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
};

const SIZES = {
  xs: 'text-[11px] px-2 py-0.5',
  sm: 'text-xs px-2.5 py-1',
  md: 'text-sm px-3 py-1.5',
};

const TagChip = ({
  tag,
  size = 'sm',
  selected = false,
  onClick = null,
  onRemove = null,
  count = null,
  className = '',
}) => {
  const tone = selected
    ? 'bg-indigo-600 text-white border-indigo-500'
    : hashToPalette(tag.slug || tag.name);

  const interactive = onClick ? 'cursor-pointer hover:brightness-125 transition' : '';
  const Element = onClick ? 'button' : 'span';

  return (
    <Element
      {...(onClick ? { type: 'button', onClick: () => onClick(tag) } : {})}
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium
        ${SIZES[size]} ${tone} ${interactive} ${className}`}
    >
      <span className="truncate max-w-[12rem]">{tag.name}</span>
      {count != null && (
        <span className="opacity-60 tabular-nums">{count}</span>
      )}
      {onRemove && (
        <span
          role="button"
          tabIndex={0}
          aria-label={`Remove ${tag.name}`}
          onClick={(e) => { e.stopPropagation(); onRemove(tag); }}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); onRemove(tag); } }}
          className="opacity-60 hover:opacity-100"
        >
          <X className="w-3 h-3" />
        </span>
      )}
    </Element>
  );
};

export default TagChip;
